<div *ngIf="sections" class="data-survey-background flex flex-col justify-center items-start">
  <div class="header-container">
    <!--    <particle-virtual-grid-->
    <!--      [sourceKey]="this.sourceKey"-->
    <!--      [invalidateSubject]="this.invalidateSubject"-->
    <!--    >-->
    <!--    </particle-virtual-grid>-->
    <platform-multicolumn-combo-box
      *ngIf="this.showMultipleColumnComboBox"
      [sourceKey]="this.sourceKey"
      [api]="this.api"
      [serviceName]="this.serviceName"
      [displayKey]="this.displayKey"
      [displayKeys]="this.displayKeys"
      [valueProperty]="this.valueProperty"
      [showedFieldKeys]="this.showedFieldKeys"
      [sortField]="this.sortField"
      [parameters]="this.parameters"
      [selectedItemsId]="this.selectedItemsId"
      [expansionPanelIndex]="this.defaultExpansionPanelIndex"
      (selectedItemChanged)="onFormValuesChanged($event)"
    >
    </platform-multicolumn-combo-box>
    <div class="floating-pagination flex flex-row justify-start items-center"
         *ngIf="!hidePagination && items.length > 1">
      <i class="fal fa-arrow-left" [ngClass]="{'disable': selectedIndex===0}" (click)="changePage(-1)"></i>
      <div class="content">{{selectedIndex + 1}} of {{itemsCount}}</div>
      <i class="fal fa-arrow-right" [ngClass]="{'disable': selectedIndex+1===itemsCount}" (click)="changePage(1)"></i>
    </div>

  </div>
  <div class="content-container">
    <div class="main-scrolling-area"
         style=" position: absolute;top: 0;left: 0;right: 0;bottom: 0;overflow: auto;padding: 30px;">
      <div class="fixed-width-area w-p-100 flex flex-col">

        <div class="root-container w-p-100 flex flex-row justify-start items-start full-grow-no-shrink-no-basis">
          <mat-accordion class="full-grow-no-shrink-no-basis">
            <mat-expansion-panel *ngFor="let section of sections; let i = index;"
                                 (opened)="section.panelOpenState = true"
                                 (closed)="section.panelOpenState = false"
                                 [expanded]="defaultExpansionPanelIndex==i ? true : section.panelOpenState">
              <mat-expansion-panel-header (click)=onSectionChange(section)>
                <mat-panel-title>
                  {{section?.title}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <particle-platform-tool-questionnaire-response
                *ngIf="section.panelOpenState"
                [section]="section"
                [rowItem]="rowItem"
                [fieldDefinitions]="fieldDefinitions"
                [fieldVisibilities]="fieldVisibilities"
                [magicLinkModel]="magicLinkModel"
                [selectedTab]="selectedTab"
                (rowItemEvent)="onUpdatedRowItem($event)"
                [flowchart]="flowchart"
                [invalidateSubject]="invalidateSubject"
                [flowChartDataService] = "flowChartDataService"
              ></particle-platform-tool-questionnaire-response>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>

</div>
